import {
  SET_ASSIGNED_STAKEHOLDERS,
  SET_STAKEHOLDERS,
  SET_MATURITY_SURVEY,
  SET_MATURITY_SURVEY_ID,
  SET_ESG_MATURITY_SCORE,
  SET_MATURITY_ASSESSMENT_DETAILS,
} from "constants/esgMaturity/esgMaturityConst";

const initial_state = {
  assigned_stakeholders: [],
  stakeholders_list: [],
  maturity_survey: [],
  survey_id: {},
  esg_maturity_score: null,
  maturity_assessment_details: null,
};

export default function reducer(state = initial_state, action) {
  switch (action.type) {
    case "RESET_STATE":
      return (state = {
        ...state,
        ...initial_state,
      });
    case SET_ASSIGNED_STAKEHOLDERS:
      return (state = {
        ...state,
        assigned_stakeholders: action.payload,
      });

    case SET_STAKEHOLDERS:
      return (state = {
        ...state,
        stakeholders_list: action.payload,
      });

    case SET_MATURITY_SURVEY:
      return (state = {
        ...state,
        maturity_survey: action.payload,
      });

    case SET_MATURITY_SURVEY_ID:
      return (state = {
        ...state,
        survey_id: action.payload,
      });

    case SET_ESG_MATURITY_SCORE:
      return (state = {
        ...state,
        esg_maturity_score: action.payload,
      });

    case SET_MATURITY_ASSESSMENT_DETAILS:
      return (state = {
        ...state,
        maturity_assessment_details: action.payload,
      });

    default:
      return state;
  }
}

// ------------------- Important Key Points -------------------
